import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';

import { Stack } from './Stack';
import { Typography as T } from './Typography/Typography';
import { useFormatMessage } from '../../hooks/useFormatMessage';

export const ProductCode = ({ code }: { code: string }) => {
  const format = useFormatMessage();

  return (
    <Stack direction="row" gap="regularMedium" alignItems="center">
      <Icon source={icons.tagFilled} size="small" fill={color.text} />
      <T.body>{code || format('common.not_available_acronym')}</T.body>
    </Stack>
  );
};
